module.exports = __webpack_public_path__ + "img/13.47f0f2d8.jpg";